/**
 * 日志工具类
 * 在开发模式下显示日志，生产模式下隐藏日志
 */

// 检测是否为开发模式
const isDev = import.meta.env.DEV || import.meta.env.NODE_ENV === 'development';

/**
 * 开发模式下的日志输出
 */
export const devLog = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  }
};

/**
 * 始终显示的日志（用于重要错误或警告）
 */
export const alwaysLog = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug
};

/**
 * 条件日志 - 只在开发模式下显示
 */
export const conditionalLog = (condition: boolean, ...args: any[]) => {
  if (condition && isDev) {
    console.log(...args);
  }
};

/**
 * 条件警告 - 只在开发模式下显示
 */
export const conditionalWarn = (condition: boolean, ...args: any[]) => {
  if (condition && isDev) {
    console.warn(...args);
  }
};

/**
 * 条件错误 - 只在开发模式下显示
 */
export const conditionalError = (condition: boolean, ...args: any[]) => {
  if (condition && isDev) {
    console.error(...args);
  }
};

export default devLog;
